<template>
  <div class="append-box" @touchmove="gtouchmove">
    <div class="new-year-2021" v-if="theme == 'newYear'">
      <div class="new-year-2021-bg"></div>
    </div>
    <div v-if="theme == 'newYear2020'" class="newYear2020">
      <img
        src="@/assets/img/theme/new-year-2020/style1.png"
        class="fireworks"
      />
      <img
        src="@/assets/img/theme/new-year-2020/style2.png"
        class="fireworks2"
      />
      <img
        src="@/assets/img/theme/new-year-2020/style3.png"
        class="fireworks3"
      />
      <img
        src="@/assets/img/theme/new-year-2020/style4.png"
        class="fireworks4"
      />
      <img
        src="@/assets/img/theme/new-year-2020/style2.png"
        class="fireworks5"
      />
    </div>
  </div>
</template>
<script>
import store from "@/store/index";
const time = 5100;
export default {
  name: "newYearScroll",
  data() {
    return {
      bounceInUp: false,
      timer: null,
      style: 1,
    };
  },
  computed: {
    theme() {
      return store.state.app.theme;
    },
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      this.timer = setTimeout(() => {
        this.close();
      }, time);
    },
    remove() {
      if (this.timer != null) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
    },
    close() {
      this.bounceInUp = true;
      setTimeout(() => {
        this.remove();
      }, 2000);
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes move {
  from {
    right: -2.26rem;
  }
  to {
    right: 100%;
  }
}

@keyframes move2 {
  from {
    bottom: -2.26rem;
  }
  to {
    bottom: 105%;
  }
}

@keyframes fireworks {
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(1);
  }
  100% {
    opacity: 0;
  }
}
@keyframes fireworks2 {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  80% {
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    transform: translate(-50%, -50%);
    opacity: 0;
  }
}
.append-box {
  z-index: 999999;
  pointer-events: none;
  .newYear2020 {
    .fireworks {
      width: 2.75rem;
      height: 3.07rem;
      right: 0;
      top: 0;
      position: absolute;
      transform: scale(0);
      animation: fireworks 8s 0s;
    }
    .fireworks2 {
      width: 2.75rem;
      height: 3.04rem;
      left: 0;
      top: 0;
      position: absolute;
      transform: scale(0);
      animation: fireworks 8s 0s;
    }
    .fireworks3 {
      width: 2.75rem;
      height: 3.11rem;
      right: 0;
      bottom: 0;
      position: absolute;
      transform: scale(0);
      animation: fireworks 8s 0s;
    }
    .fireworks4 {
      width: 1.86rem;
      height: 2.005rem;
      left: 0;
      bottom: 0;
      position: absolute;
      transform: scale(0);
      animation: fireworks 8s 0s;
    }
    .fireworks5 {
      width: 2.75rem;
      height: 3.04rem;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      transform: scale(0);
      animation: fireworks2 8s 0s;
    }
  }
  .bg-box {
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 301;
    height: 2.72rem;
    width: 3.94rem;
    transform: translate(0, -50%) scale(0.8);
    .ani-bg-box {
      -webkit-animation-duration: 2s;
      animation-duration: 2s;
      width: 100%;
      height: 100%;
      display: table;
      .left-bg {
        width: 1.97rem;
        height: 2.72rem;
        background-image: url(~@/assets/img/theme/new-year/gongxifacai_01.png);
        background-repeat: no-repeat;
        background-size: cover;
        display: table-cell;
      }
      .right-bg {
        width: 1.97rem;
        height: 2.72rem;
        display: block;
        background-image: url(~@/assets/img/theme/new-year/wanshiruyi_01.png);
        background-repeat: no-repeat;
        background-size: cover;
        display: table-cell;
      }
    }
  }
  .new-year-2021 {
    width: 2.27rem;
    height: 1.365rem;
    position: fixed;
    right: -2.26rem;
    bottom: 0;
    animation: move 5s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    .new-year-2021-bg {
      width: 2.27rem;
      height: 1.365rem;
      display: block;
      background-image: url(~@/assets/img/theme/new-year-2021/zs_bottom.png);
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .bg-box2 {
    height: 3.6rem;
    width: 100%;
    left: 50%;
    display: block;
    position: fixed;
    top: 50%;
    z-index: 301;
    transform: translate(-50%, -50%) scale(0.9);
    .ani-bg-box {
      -webkit-animation-duration: 2s;
      animation-duration: 2s;
      width: 100%;
      height: 100%;
      .left-bg {
        width: 1.97rem;
        height: 2.72rem;
        background-image: url(~@/assets/img/theme/new-year/gongxifacai_01.png);
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        left: 0;
        top: 0;
      }
      .right-bg {
        width: 1.97rem;
        height: 2.72rem;
        display: block;
        background-image: url(~@/assets/img/theme/new-year/wanshiruyi_01.png);
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
  .bg-box3 {
    display: block;
    position: absolute;
    left: 0.6rem;
    top: 50%;
    z-index: 301;
    height: 2.72rem;
    width: 3.94rem;
    transform: translate(0, -50%) scale(0.8);
    .ani-bg-box {
      -webkit-animation-duration: 2s;
      animation-duration: 2s;
      width: 100%;
      height: 100%;
      display: table;
      .left-bg {
        width: 1.97rem;
        height: 2.72rem;
        background-image: url(~@/assets/img/theme/new-year/gongxifacai_01.png);
        background-repeat: no-repeat;
        background-size: cover;
        display: table-cell;
      }
      .right-bg {
        width: 1.97rem;
        height: 2.72rem;
        display: block;
        background-image: url(~@/assets/img/theme/new-year/wanshiruyi_01.png);
        background-repeat: no-repeat;
        background-size: cover;
        display: table-cell;
      }
    }
  }
}
@media all and (orientation: portrait) {
  .bg-box {
    top: 0.2rem !important;
    left: 50% !important;
    transform: translate(-50%, 0) rotate(90deg) scale(0.8) !important;
  }
  .bg-box2 {
    width: 6.4rem !important;
    transform: translate(-50%, -50%) rotate(90deg) scale(0.9) !important;
    .left-bg {
      top: 50% !important;
      left: 0 !important;
      transform: translate(0, -50%) !important;
    }
    .right-bg {
      top: 50% !important;
      right: 0 !important;
      transform: translate(0, -50%) !important;
    }
  }
  .bg-box3 {
    top: 1.2rem !important;
    left: 50% !important;
    transform: translate(-50%, 0) rotate(90deg) scale(0.8) !important;
  }

  .new-year-2021 {
    width: 1.365rem;
    height: 2.27rem;
    position: fixed;
    left: 0;
    bottom: -2.26rem;
    animation: move2 5s !important;
    animation-timing-function: linear !important;
    animation-fill-mode: forwards !important;
    .new-year-2021-bg {
      transform: rotate(90deg);
      width: 2.27rem;
      height: 1.365rem;
      display: block;
      background-image: url(~@/assets/img/theme/new-year-2021/zs_bottom.png);
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}
</style>